import { useState, useRef, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Typography,
    Box,
    DialogActions,
    Button,
    Link,
    Paper
} from "@mui/material";
import Draggable from "react-draggable";
import QRCode from "react-qr-code";
import WhatsappLogo from "../../../assets/whatsapp.png";

export default function DialogContato() {
    const [open, setOpen] = useState(false);
    const dragged = useRef(false);
    const [anyDialogOpen, setAnyDialogOpen] = useState(false);


    useEffect(() => {
        const observer = new MutationObserver(() => {
            const dialogs = document.querySelectorAll('[role="dialog"]');
            const visibleDialogs = Array.from(dialogs).some(
                (dialog) => window.getComputedStyle(dialog).display !== "none"
            );
            setAnyDialogOpen(visibleDialogs);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Draggable
                defaultPosition={{ x: 0, y: 0 }}
                onStart={() => { dragged.current = false; }}
                onDrag={() => { dragged.current = true; }}
            >
                <Paper
                    elevation={0}
                    sx={{
                        position: "fixed",
                        bottom: 80,
                        right: 20,
                        cursor: "pointer",
                        zIndex: 9999,
                        width: 60,
                        height: 60,
                        alignItems: "center",
                        justifyContent: "center",
                        p: 0,
                        m: 0,
                        borderRadius: "50%",
                        boxShadow: "none",
                        background: "transparent",
                        display: anyDialogOpen ? "none" : "flex",
                    }}
                    onClick={() => {
                        if (!dragged.current) setOpen(true);
                    }}
                >
                    <img
                        style={{
                            width: 60,
                            height: 60,
                            userSelect: "none",
                            pointerEvents: "none"
                        }}
                        src={WhatsappLogo}
                        alt="Whatsapp logo"
                        draggable={false}
                    />
                </Paper>
            </Draggable>

            <Dialog onClose={() => setOpen(false)} open={open} maxWidth="xs">
                <DialogTitle>
                    <Typography variant="h6">Suporte Techpines pelo Whatsapp</Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        Acesse o grupo para enviar sua dúvida, crítica ou sugestão. Leia
                        QRCode abaixo com seu celular ou{" "}
                        <Link
                            href="https://chat.whatsapp.com/LxD2vTs8WagI43J9M6Zjy6"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                            color="primary"
                        >
                            acesse esse link
                        </Link>
                    </Typography>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: 2,
                            marginBottom: 2,
                        }}
                    >
                        <QRCode
                            style={{ height: "auto", width: "80%" }}
                            value="https://chat.whatsapp.com/LxD2vTs8WagI43J9M6Zjy6"
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setOpen(false)}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}